import React from "react";
import { WizTreeSelectPlus } from '@/containers/common'

/**
 * PositionSelectOrgList 岗位选择组织配置
 * @author mll
 * @date 2020-01-09
 */
export default () => {
    return [
        {
            title: 'id',
            name: 'id',
            formItem: {
                type: 'hidden'
            }
        },
        {
            title: '组织名称',
            name: 'name',
            tableItem: {},
            searchItem: {
            }
        },
        {
            title: '组织编码',
            name: 'code',
            tableItem: {},
            searchItem: {
            }
        },
        {
            title: '组织类型',
            name: 'organizationNodeCategoryName',
            tableItem: {},
        },
        {
          title: '组织类型',
          name: 'organizationNodeCategory',
          searchItem: {
            type: 'diy',
            diy: (props) => <WizTreeSelectPlus { ...props } />
          }
        },
        {
            title: '组织状态',
            name: 'state',
            dict: [
                { code: 1, codeName: '有效' },
                { code: 0, codeName: '无效' },
            ],
            tableItem: {},
            searchItem: {
                type: 'select',
            }
        }
    ]
}
